/*globals window, $ */

/**
  * variables for easy access to commonly used sizes
  */
var mobileSize = 768,
    fiveEighty = 580,
    mobileMenuSize = 992,
    sliderMobileBreakpoint = mobileMenuSize;

/**
  * Local offer data storate
  */
var offersData;

/**
 * Retail product types display
 */
var retailData = {
    "retail_has_cartons": "Cartons",
    "retail_has_cups": "Cups",
    "retail_has_rolls": "Rolls",
    "retail_has_novelty": "Bars, Cones & More",
    "retail_has_bakery": "Cakes (Bakery)",
    "retail_has_frozen": "Cakes (Frozen Aisle)",
    "retail_has_sig_sundaes": "Signature Sundaes",
    "retail_has_naturally": "Naturally Friendly's<span class=\"tm\">&trade;</span>",
};

/**
  * Convienent does x object exist and not contain nothing method
  */
$.fn.exists = function () {
    "use strict";

    return this.length !== 0;
};

/**
  * Convienent method to detect if screen size is 768px or less
  */
function isMobile() {
    "use strict";

    return $(window).width() < mobileSize;
}

/**
  * Swap navbar with search menu when the search icon is clicked and show the
  * mobile search and menu if on mobile.
  */
function checkMobile() {
    "use strict";

    var menuSearchResults = $("#menuSearch").find("[data-searchresults]");

    if (isMobile()) {
        // Footer menu
        $("[data-collapse]").attr("data-toggle", "collapse");
        menuSearchResults.css("max-height", ($(window).height() - parseInt(menuSearchResults.css("top"), 10)) + "px");
        setSearchPlaceholder("small");
    } else {
        // Footer menu
        $("[data-collapse]").attr("data-toggle", false);

        // Search bar
        if ($(window).width() < mobileMenuSize) {
            setSearchPlaceholder("medium");
        } else {
            setSearchPlaceholder();
        }
    }
}

function getURLParameter(name) {
    "use strict";

    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

function addEvent(name, params) {
    "use strict";
    var event, eventParams = params || {};
    if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
        event = document.createEvent("CustomEvent");
        event.initCustomEvent(name, false, false, eventParams);
    } else {
        event = new CustomEvent(name, {"detail": eventParams});
    }
    window.dispatchEvent(event);
}

function sendGAEvent(target, action, category) {
    "use strict";

    var event = target.data("ga-event");
    
    if (!event) {
        event = action;
    }

    // Google Analytics
    ga('send', 'event', category, action, event);
    
    // Facebook
    fbq('track', 'ViewContent', {
        content_name: event,
        content_category: category
    });
}

function getPostId() {
    "use strict";
    try {
        return /\s*(page-id|postid)-(\d+)\s*/.exec($("body")[0].className)[2];
    } catch (e) {
        return null;
    }
}

function setSearchPlaceholder(screenSize) {
    "use strict";

    var mainSearchForm = $("#searchForm"),
        mainSearchDropdown = mainSearchForm.find(".dropdown-menu"),
        mainSearchInput = mainSearchForm.find("[data-search]"),

        pageSearchForm = $("#pageSearchForm"),
        pageSearchPlaceholder;

    if (pageSearchForm) {
        switch($("body").attr("id")) {
        case "pageSearch":
            pageSearchPlaceholder = "What are you looking for?";
            break;
        case "pageJobs":
            pageSearchPlaceholder = "Search by keyword or location";
            break;
        default:
            pageSearchPlaceholder = "Search by name or ingredient";
            break;
        }
        pageSearchForm.find("[data-search]").attr("placeholder", pageSearchPlaceholder);
        pageSearchForm.find("[data-search]").attr("aria-label", pageSearchPlaceholder);
    }

    switch (screenSize) {
    case "small":
    case "medium":
        mainSearchDropdown.css("width", "100%").parent().css("z-index", "100");
        mainSearchInput.attr("placeholder", "");
        mainSearchInput.attr("aria-label", "Search");
        break;
    default:
        mainSearchDropdown.css("width", "calc(100% - " + $(".nav-item-home").outerWidth() + "px)").parent().css("z-index", "inherit");
        mainSearchInput.attr("placeholder", "Search ice cream and menu items");
        mainSearchInput.attr("aria-label", "Search ice cream and menu items");
        break;
    }
}

function initHomepageSlider(sliderNode) {
    "use strict";

    if ($(".slider.retail").length === 0) {
        return;
    }

    var sliderImages,
        imgNode,
        imgHolder,
        minImgHeight = 0,
        imageHeight = 0,
        imageNum = 0;

    sliderNode.slick({
        dots: true,
        useTransform: true,
        cssEase: "ease-in-out",
        arrows: false,
        lazyLoad: "ondemand"
    });

    sliderImages = sliderNode.find(".pic");
    // sliderNode.find(".slick-slide").removeClass("hide");

    $.each(sliderImages, function () {
        imgNode   = $(this),
        imgHolder = $("<img>", {
            "src": imgNode.css("background-image").replace(/url\((['"])?(.*?)\1\)/gi, '$2').split(',')[0]
        });

        imgHolder.on("load", function() {
            imageHeight = $(this)[0].height; //parseInt(getComputedStyle(imgNode[0]).height, 10);
            imageNum += 1;
            if (minImgHeight === 0 || imageHeight < minImgHeight) {
                minImgHeight = imageHeight;
            }
            if (imageNum >= sliderImages.length) {
                sliderImages.find("img.mainImg").css("max-height", minImgHeight + "px");
            }
        });
    });
}

/**
  * Part of ADA Compliance on the "Remember Me" checkbox on the login page
  */
$('.login-remember label').attr("for", "rememberme");

$('.nav-item-search').on('show.bs.dropdown', function(){
  var $this = $(this);

  $this.parent().parent().addClass("search-open");
});

$('.nav-item-search').on('hide.bs.dropdown', function(){
  var $this = $(this);

  $this.parent().parent().removeClass("search-open");
});

$('.offer .actions a').click(function(e){

  e.preventDefault();

  var $this = $(this);
      offerWrapper = $this.parent().parent(),
      buttonText = $this.text(),
      remainingRows = offerWrapper.find(".notShown"),
      state = $this.attr("aria-expanded") == "false" ? "closed" : "open";

  if(state == "closed"){

    remainingRows.slideDown();

    $this.attr("aria-expanded", "true");
    $this.text(buttonText.replace("Show", "Hide"));

  } else {

    remainingRows.slideUp();

    $this.attr("aria-expanded", "false");
    $this.text(buttonText.replace("Hide", "Show"));

  }

  return false;
});

$('.bottomContainer .actions a').click(function(e){

  e.preventDefault();

  var $this = $(this);
      offerWrapper = $this.parent().parent(),
      buttonText = $this.text(),
      remainingRows = offerWrapper.find(".notShown"),
      state = $this.attr("aria-expanded") == "false" ? "closed" : "open";

  if(state == "closed"){

    remainingRows.slideDown();

    $this.attr("aria-expanded", "true");
    $this.text(buttonText.replace("Show", "Hide"));

  } else {

    remainingRows.slideUp();

    $this.attr("aria-expanded", "false");
    $this.text(buttonText.replace("Hide", "Show"));

  }

  return false;
});

/**
  * Show "Carry Friendly's" dropdown on click of the "Get Started" button
  */
$('.carryfriendlysPage a.btn.btn-default').filter("[data-modal]").click(function(e){
  e.preventDefault();

  var $this = $(this),
      target = $this.attr("data-target");

  // get value of "data-target" and put it as the selector below
  $(target).modal('show');

  return false;
});

// give focus to the search input on search button click
$('.nav-item-search a').on('click', function() {
  setTimeout(function () { $('#menuSearch form input.form-control').focus(); }, 100);
});

/**
 * Send form data through email via ajax
 */
function sendFormData(form) {
    "use strict";

    var formType = form.data("form"),
        formData = {};

    $.each(form.find(".inputBox"), function () {
        var inputLabel = $(this).find("label"),
            inputKey = inputLabel.text(),
            inputVal = $(this).find("input, textarea, select").val();

        if (inputLabel.hasClass("required-field") || (inputKey && inputKey !== "" && inputVal && inputVal !== "")) {
            formData[inputKey] = inputVal;
        }
    });

    var sendForm = $.ajax({
        type: "post",
        url: ajaxUrl,
        dataType: "json",
        data: {
            "action": "send_form_data",
            "type": formType,
            "data": formData,
            "recaptcha": grecaptcha.getResponse()
        }
    });

    sendForm.done(function (result) {
        var formContainer = $("[data-form-container]"),
            messageContainer = $("[data-form-message]"),
            resultMessage = result.error ? result.message : "Sorry, there was a problem. Please try again later.";
        
        $.each($("[data-form-container]"), function (key, value) {
            if ($.contains(value, form[0])) {
                formContainer = $(this);
                return false;
            }
        });
            
        // Validation failed
        if (result.error === 2) {
            messageContainer.find(".error-text").remove();
            messageContainer.append("<span class=\"error-text\"><br /><br />" + resultMessage + "<br /></span>");
        } else {
            messageContainer.html(resultMessage + "<br /><br />");

            if (formContainer.find(form).length > 0) {
                formContainer.addClass("hide");
            }
        }

        if (formContainer.parent().hasClass("modal-content")) {
            $(".modal").scrollTop(0);
        } else {
            $(document).scrollTop(0);
        }
    });
}

/**
  * Tab functionality on Nutrition and Allergens Page
  */

$('.segmentedControlContainer a').click(function(e){
  e.preventDefault();

  var $this = $(this),
      buttons = $this.parent().find('a'),
      buttonText = $this.text().toLowerCase(),
      subCategory = $this.parent().parent().attr("class").split(/\s+/)[1],
      subCategoryItems = $("." + subCategory);

  buttons.each(function(i, o){
     $(o).removeClass("active");
  });

  $this.addClass("active");

  var activeItems = subCategoryItems.filter("." + buttonText),
      inactiveTab = (buttonText == "nutrition") ? "allergens" : "nutrition",
      inactiveItems = subCategoryItems.filter("." + inactiveTab);

  inactiveItems.each(function(i, o){
    $(o).hide();
  });

  activeItems.each(function(i, o){
    $(o).show();
  });

  return false;
});